import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useAuthStore } from 'common/stores';
import { Wrapper } from 'core/components/common';
import { PasswordInput, TextInput } from 'core/components/form';
import CircularIndicator from 'core/components/uikit/CircularIndicator';
import { PATHS } from 'core/router';

import { LoginFormData, loginSchema } from './validationSchema';

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useForm<LoginFormData>({
    resolver: yupResolver(loginSchema),
    mode: 'all',
    defaultValues: { email: '', password: '' },
  });

  const isButtonDisabled = !isValid || isSubmitting;

  const onSubmit = handleSubmit(async ({ email, password }) => {
    const data = await useAuthStore.getState().signIn({ email, password });

    if (!data || !data.otpAccessToken) return;

    navigate(PATHS.getOtpVerify({ otpAccessToken: data.otpAccessToken }));
  });

  return (
    <Wrapper internalClassName="!max-w-md">
      <form className="flex flex-col gap-4" onSubmit={onSubmit}>
        <TextInput
          control={control}
          name="email"
          componentProps={{
            placeholder: t('pages.login.fields.email'),
          }}
        />
        <PasswordInput
          control={control}
          name="password"
          componentProps={{
            placeholder: t('pages.login.fields.password'),
          }}
        />
        <button type="submit" disabled={isButtonDisabled}>
          {isSubmitting ? <CircularIndicator /> : t('common.continue')}
        </button>
      </form>
    </Wrapper>
  );
};

export default Login;
